import type { BadgeColor } from '@billy/design-system'

import { EInvoiceStatus } from './eInvoiceStatus'

interface EInvoiceStatusBadgeConfig {
  color: BadgeColor
  labelKey: string
}

export const BLOCKED_E_INVOICE_STATUS_BADGE: Partial<Record<EInvoiceStatus, EInvoiceStatusBadgeConfig>> = {
  [EInvoiceStatus.Refused]: { color: 'neutral', labelKey: 'receipts.receipts_list.type.refused' },
  [EInvoiceStatus.Suspended]: { color: 'warning', labelKey: 'receipts.receipts_list.type.suspended' },
  [EInvoiceStatus.Disputed]: { color: 'warning', labelKey: 'receipts.receipts_list.type.disputed' },
  [EInvoiceStatus.Approved]: { color: 'success', labelKey: 'receipts.receipts_list.type.approved' },
  [EInvoiceStatus.PaymentReceived]: { color: 'success', labelKey: 'receipts.receipts_list.type.cashed' },
}
